import * as React from 'react';
import LexiconEntryMatch from '../new/lexicons/LexiconEntryMatch';
import './LexiconEntry.css';

interface Props {
    match: LexiconEntryMatch;
}

export default class LexiconEntry extends React.Component<Props> {

    public render() {
        const match = this.props.match;
        return (
            <div className="LexiconEntry">
                <div className="LexiconEntry_LeftMargin">
                    <div className="LexiconEntry_Number _Default" title={match.getLexicon().getName()}
                        dangerouslySetInnerHTML={{ __html: match.getLexicon().formatEntryTitle(match) }} />
                </div>
                <div className="LexiconEntry_Text" dangerouslySetInnerHTML={{ __html: match.getText() }} />
            </div>
        );
    }
}
